// Componente para o header da página de edição
import { Link } from 'react-router-dom';
import { ArrowLeft, Save } from 'lucide-react';
import { LockIndicator } from '@/components/lock/LockIndicator';
import { LockInfo } from '@/hooks/useLock';
import { useI18n } from '@/contexts/i18n-hook';

interface EditHeaderProps {
  titulo: string;
  numero?: string;
  lockInfo: LockInfo | null;
  eMeuLock: boolean;
  bloqueadoPorOutro: boolean;
  onSave: (e: React.FormEvent) => void | Promise<void>;
  saving: boolean;
  disabled?: boolean;
}

export function EditHeader({
  titulo,
  numero,
  lockInfo,
  eMeuLock,
  bloqueadoPorOutro,
  onSave,
  saving,
  disabled = false,
}: EditHeaderProps) {
  const { t } = useI18n();

  return (
    <div className="space-y-4">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center">
          <Link
            to="/apreciacoes"
            className="mr-4 p-2.5 rounded-lg text-schmersal-gray-medium 
                     hover:text-schmersal-blue hover:bg-schmersal-gray-light 
                     transition-colors duration-200"
          >
            <ArrowLeft className="h-5 w-5" />
          </Link>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-schmersal-blue dark:text-white">
              {titulo}
            </h1>
            {numero && (
              <p className="mt-1 text-sm text-schmersal-gray-medium dark:text-schmersal-gray-light">
                {numero}
              </p>
            )}
          </div>
        </div>

        <button
          type="submit"
          onClick={onSave}
          disabled={saving || disabled || (bloqueadoPorOutro && !eMeuLock)}
          className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg 
                   hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed 
                   transition-colors duration-200"
        >
          <Save className="h-5 w-5" />
          {saving ? t('comum.acao.salvando') : t('comum.acao.salvar')}
        </button>
      </div>

      {lockInfo && (
        <LockIndicator
          lockInfo={lockInfo}
          eMeuLock={eMeuLock}
          bloqueadoPorOutro={bloqueadoPorOutro}
        />
      )}
    </div>
  );
}

